class BasicMesswert {
  einheit: string;
  text: string ='';
  wert: number;
}

export class VorhersageMesswerte extends BasicMesswert {
  gueltigBisLokaleZeit: Date;
  gueltigBisUTC: Date;
  gueltigVonLokaleZeit: Date;
  gueltigVonUTC: Date;
  bewoelkung: BasicMesswert;
  bodenTemperaturMaximum: BasicMesswert;
  bodenTemperaturMinimum: BasicMesswert;
  gefuehlteTemperaturMaximum: BasicMesswert;
  gefuehlteTemperaturMinimum: BasicMesswert;
  luftTemperaturMaximum: BasicMesswert;
  luftTemperaturMinimum: BasicMesswert;
  luftdruck: BasicMesswert;
  luftfeuchtigkeitMaximum: BasicMesswert;
  luftfeuchtigkeitMinimum: BasicMesswert;
  mittlereWindGeschwindigkeit: BasicMesswert;
  niederschlagsMenge: BasicMesswert;
  niederschlagsWahrscheinlichkeit: BasicMesswert;
  sichtweite: BasicMesswert;
  sonnenscheinDauer: BasicMesswert;
  taupunktMaximum: BasicMesswert;
  taupunktMinimum: BasicMesswert;
  wettersymbol: BasicMesswert;
  windBoeMaximum: BasicMesswert;
  windRichtung: BasicMesswert;
}

